import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Users from '../UserList/Users';
import SubscriptionStudySelector from './SubscriptionStudySelector';
import { CROSSTAB_FEATUREID } from '../../../constants';
import { saveSubscription } from '../../../actions/entitlementsActions';

class CreateSubscription extends Component {
  static propTypes = {
    accountDetail: PropTypes.instanceOf(Object),
    updatedActivePage: PropTypes.func,
    selectedEntitlement: PropTypes.instanceOf(Object),
    entitlementTeams: PropTypes.instanceOf(Array),
    entitlementUsers: PropTypes.instanceOf(Array),
    handleBack: PropTypes.func,
    hasAccess: PropTypes.bool,
  };

  static defaultProps = {
    accountDetail: {},
    selectedEntitlement: {},
    entitlementUsers: [],
    entitlementTeams: [],
    hasAccess: 0,
  };

  state = {
    allUsers: [],
    allTeams: [],
    activeUsers: [],
    activeTeams: [],
    clearUsers: false,
    serviceError: '',
    successMessage: '',
    entitlement: {},
    studyGroup: [],
  };

  componentDidMount() {
    this.updateInitialValues();
  }

  updateInitialValues = () => {
    const {
      accountDetail,
      entitlementUsers,
      entitlementTeams,
      selectedEntitlement,
    } = this.props;
    const activeUsers = [];
    const activeTeams = [];
    if (!_.isEmpty(entitlementUsers)) {
      entitlementUsers.map(user => {
        activeUsers.push(user);
        return false;
      });
    }
    if (!_.isEmpty(entitlementTeams)) {
      entitlementTeams.map(team => {
        activeTeams.push(team);
        return false;
      });
    }

    this.setState({
      activeUsers: selectedEntitlement.id ? activeUsers : [],
      activeTeams: selectedEntitlement.id ? activeTeams : [],
      entitlement: selectedEntitlement,
      allUsers: accountDetail.users,
      allTeams: accountDetail.teams.filter(item => item.activeStatus === 'Y'),
      studyGroup: selectedEntitlement.studyGroup,
    });
  };

  updateSelectedItems = activeUsers => {
    this.setState({ activeUsers });
  };

  handleReset = () => {
    this.setState(
      {
        clearUsers: false,
        hasError: false,
      },
      () => {
        this.updateInitialValues();
      }
    );
  };

  handleSave = () => {
    const { activeUsers, entitlement, allUsers, allTeams } = this.state;
    const { accountDetail } = this.props;

    const users = [];
    const teams = [];

    _.map(allUsers, user => {
      _.map(activeUsers, item => {
        if (item.type === 'USER' && item.itemId === user.userId) {
          users.push(user);
        }
      });
    });
    _.map(allTeams, team => {
      _.map(activeUsers, item => {
        if (item.type === 'TEAM' && item.itemId === team.id) {
          teams.push(team);
        }
      });
    });
    const accountId = accountDetail.accountId;
    const request = {
      ...entitlement,
      users,
      teams,
    };

    this.setState(
      { hasError: false, serviceError: '', successMessage: '' },
      () => {
        saveSubscription(accountId, request).then(response => {
          if (response.data === 'SUCCESS') {
            this.setState(
              { successMessage: 'Subscriptions saved successfully' },
              () => {
                if (this.state.successMessage) {
                  setTimeout(() => {
                    this.props.updatedActivePage({
                      activeSubscriptionsPage: 'SUBSCRIPTIONS',
                    });
                  }, 2000);
                }
              }
            );
          }
          if (response.error) {
            this.setState({ serviceError: response.error, hasError: true });
          }
        });
      }
    );
  };

  _isDisabled = () => {
    let hasUpdated = false;
    const { activeUsers } = this.state;
    const { entitlementUsers, entitlementTeams } = this.props;

    const actualUsers = _.orderBy(_.map(entitlementUsers, item => item.userId));
    const actualTeams = _.orderBy(_.map(entitlementTeams, item => item.id));

    const updatedUsers = _.orderBy(
      _.map(
        _.filter(activeUsers, item => item.type === 'USER'),
        a => a.itemId
      )
    );
    const updatedTeams = _.orderBy(
      _.map(
        _.filter(activeUsers, item => item.type === 'TEAM' && item.itemId),
        a => a.itemId
      )
    );

    const isEqualUsers = _.isEqual(actualUsers, updatedUsers);
    const isEqualTeams = _.isEqual(actualTeams, updatedTeams);

    hasUpdated = isEqualUsers && isEqualTeams;
    return this.props.hasAccess ? hasUpdated : true;
  };

  render() {
    const {
      serviceError,
      successMessage,
      studyGroup,
      allUsers,
      allTeams,
      activeUsers,
      activeTeams,
    } = this.state;
    const { selectedEntitlement, handleBack } = this.props;
    let errorMessage = '';
    if (serviceError) {
      errorMessage = serviceError;
    }

    const isDisabled = this._isDisabled();

    return (
      <div className="accounts-role">
        {errorMessage && <span className="error-message">{errorMessage}</span>}
        {successMessage && (
          <span className="success-message">{successMessage}</span>
        )}
        <div className="accounts-details-card-header">
          <div className="role-title">
            <h4>{selectedEntitlement.name}</h4>
          </div>
          <div className="adduser-card-actions roles-actions">
            <button
              onClick={this.handleSave}
              className="btn saveButton"
              disabled={isDisabled}
            >
              <span>Save &amp; Apply</span>
            </button>
            <button
              className="btn resetButton"
              onClick={this.handleReset}
              disabled={isDisabled && !this.props.hasAccess}
            >
              Reset
            </button>
            <button onClick={handleBack} className="btn cancelButton">
              <span>Cancel</span>
            </button>
          </div>
        </div>
        <div
          className="accounts-role--details custom-account-block"
          style={{ paddingTop: '20px' }}
        >
          <div className="accounts-role-users--wrapper">
            <div className="accounts-role-users">
              <h4>Active Studies</h4>
              {studyGroup.length > 0 ? (
                <SubscriptionStudySelector
                  studies={studyGroup}
                  featureID={CROSSTAB_FEATUREID}
                />
              ) : (
                <div
                  className="no-result-message"
                  style={{ paddingLeft: '20px' }}
                >
                  There are no Study currently assigned to this Subscription.
                </div>
              )}
            </div>
          </div>
          <div className="accounts-role-users--wrapper">
            <div className="accounts-role-users">
              <h4>Select User(s)</h4>
              <Users
                users={allUsers}
                activeUsers={activeUsers}
                activeTeams={activeTeams}
                teams={allTeams}
                updateSelectedItems={this.updateSelectedItems}
                clearUsers={this.state.clearUsers}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateSubscription;
